import { Plane } from "lucide-react";

const words = ["Aviation Software", "Capability Delivery", "Systems Integration", "Data & Insight", "Made in Australia"];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {words.map((w) => (
      <span key={w} className="flex items-center">
        <span className="px-8 font-serif text-4xl italic text-ink sm:px-12 sm:text-6xl">{w}</span>
        <Plane className="h-6 w-6 rotate-45 text-sky-500 sm:h-8 sm:w-8" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="relative overflow-hidden border-y border-sky-100 bg-white py-8 sm:py-10" data-testid="editorial-marquee">
    <div className="marquee-track flex w-max">
      <Row />
      <Row hidden />
    </div>
  </section>
);
